import React from "react";
import { useNavigate } from "react-router-dom";

const CustomBreadcrumbs = ({ pathTitle, className }) => {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <nav aria-label="breadcrumb" className={className ? className : "mb-2"}>
      <ol className="breadcrumb border-bottom formBackground px-2 py-2" style={{ marginBottom: "5px"}}>
        <div className="d-flex align-items-center justify-content-between w-100">
          <li className="breadcrumb-item">{pathTitle}</li>
          {/* Add by Victor: Agrega boton para limpiar la pantalla (navega hacia el dashboard) */}
          <button
            style={{
              border: "1px solid #b0b0b0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.2s ease",
              backgroundColor: isHovered ? "#ff4136" : "",
            }}
            className="btn"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={() => navigate("/dashboard")}
          >
            <i 
              style={{ 
                fontSize: "20px", 
                color: isHovered ? "#ffffff" : "#b0b0b0",
                transition: "color 0.2s ease"
              }} 
              className="fa-solid fa-xmark"
            ></i>
          </button>
        </div>
      </ol>
    </nav>
  );
};

export default CustomBreadcrumbs;
